const cookiesParse = () => {
    let _cookies = document.cookie;

    let response = [];
    let arr_cookies = [];

    if (_cookies.indexOf(";") > 0) {
        arr_cookies = _cookies.replace(/\s/g, "").split(";");
    } else {
        arr_cookies.push(_cookies.replace(/\s/g, ""));
    }

    if (arr_cookies) {
        arr_cookies.map((a_cookie) => {

            let row = a_cookie.split("=")

            response.push({
                'key': row[0],
                'value': row[1]
            })
        });
    }

    return response;
}

const getExpires = (time = undefined) => {
    let d = new Date();
    if (time === undefined) {
        time = 365 * 24 * 60 * 60 * 1000;
    } else {
        time = time * 60 * 1000;
    }
    d.setTime(d.getTime() + time);
    //console.log("[COOKIE] time of getExpires", d.toUTCString(), time);
    let expires = "expires=" + d.toUTCString();
    return expires;
}

export {
    cookiesParse,
    getExpires
}